import './PageOverview.css';
import { motion } from 'framer-motion';

const PageOverView = ({ text, description = "" }) => {
    return (
        <motion.div
            key="div0"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.7 }}
        >
            <header className="hero">
                <h1>{text}</h1>
                {description && <p> {description} </p>}
            </header>
        </motion.div>
    )
}

export default PageOverView;